import { IntegrityMonitorRulesGridGzDataProvider } from '../dataProvider/IntegrityMonitorRulesGridGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class IntegrityMonitorRulesGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorRulesGridGzDataProvider);
  }
}
